/** @type {import('./types').Client} */
let client;

/**
 * @param {{
 *   client: import('./types').Client;
 * }} opts
 */
function init(opts) {
	client = opts.client;
}

export { client, init };
